var map = {
	"./AllLoanCenter.png": 9101,
	"./AmoozeshgahAzad.png": 7697,
	"./BarFrooshiWinAccounting.png": 8171,
	"./BusinesseWinAccounting.png": 6553,
	"./HanaAccounting.png": 3904,
	"./ProductWinAccounting.png": 9215,
	"./ResturantWinAccounting.png": 2342,
	"./SalaryCertificate.png": 5882,
	"./ServiceWinAccounting.png": 9087,
	"./SimpleWinAccounting.png": 7534,
	"./TaxService.png": 3609,
	"./VisitoryWinAccounting.png": 4245,
	"./WorkersWinAccounting.png": 27,
	"./complex_school.png": 8410,
	"./independent_school.png": 3480
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 806;